import { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';


const desktopVideo = "/videos/Video8.mp4";
const mobileVideo  = "/videos/Video5.mp4";

export default function Hero() {
  const [isMobile, setIsMobile] = useState(false);
  const mobileVideoRef  = useRef<HTMLVideoElement>(null);
  const desktopVideoRef = useRef<HTMLVideoElement>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 768);
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  useEffect(() => {
    if (isMobile) {
      const vid = mobileVideoRef.current;
      if (!vid) return;
      vid.muted = true;
      vid.playsInline = true;
      vid.play().catch((err) => console.warn('Mobile autoplay blocked:', err));
    } else {
      const vid = desktopVideoRef.current;
      if (!vid) return;
      vid.muted = true;
      vid.playsInline = true;
      vid.play().catch((err) => console.warn('Desktop autoplay blocked:', err));
    }
  }, [isMobile]);

  const scrollToCars = () => {
    document.getElementById('featured-cars')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section style={{ position: 'relative', width: '100%', height: '80vh', overflow: 'hidden' }}>

      {/* VIDEO */}
      {isMobile ? (
        <video
          ref={mobileVideoRef}
          src={mobileVideo}
          autoPlay muted loop playsInline
          style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', zIndex: 1 }}
        />
      ) : (
        <video
          ref={desktopVideoRef}
          src={desktopVideo}
          autoPlay muted loop playsInline
          style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', zIndex: 1 }}
        />
      )}

      {/* OVERLAY */}
      <div style={{
        position: 'absolute', inset: 0, zIndex: 2,
        background: isMobile
          ? 'linear-gradient(to top, rgba(0,0,0,0.85), rgba(0,0,0,0.2))'
          : 'linear-gradient(to bottom, rgba(0,0,0,0.55), rgba(0,0,0,0.8))',
      }} />

      {/* CONTENT */}
      <div style={{
        position: 'relative', zIndex: 3, height: '100%',
        display: 'flex',
        alignItems: isMobile ? 'flex-end' : 'center',
        justifyContent: isMobile ? 'flex-end' : 'center',
        flexDirection: 'column',
        textAlign: isMobile ? 'left' : 'center',
        padding: isMobile ? '20px' : '16px',
      }}>
        <h1 style={{ fontSize: isMobile ? 24 : 32, fontWeight: 700, lineHeight: 1.2 }}>
          Find Your <span style={{ color: '#FFD700' }}>Perfect</span> Drive
        </h1>
        <p style={{ color: '#ccc', fontSize: isMobile ? 13 : 14, marginTop: 8 }}>
          Browse certified vehicles with best pricing
        </p>

        {/* BUTTON ROW */}
        <div style={{
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          gap: '10px',
          marginTop: 16,
          width: isMobile ? '100%' : 'auto',
        }}>
          {/* Animated down arrow */}



{/* See All Cars */}
<button
  onClick={scrollToCars}
  style={{
    display: 'inline-flex', alignItems: 'center', gap: '10px',
    padding: '14px 20px 14px 28px', borderRadius: '12px',
    background: '#FFD700', border: 'none', cursor: 'pointer',
    fontSize: isMobile ? '14px' : '15px', fontWeight: 700, color: '#000',
    letterSpacing: '-0.01em', width: isMobile ? '100%' : 'auto',
    transition: 'transform 0.2s, box-shadow 0.2s',
  }}
  onMouseEnter={e => {
    (e.currentTarget as HTMLButtonElement).style.transform = 'translateY(-2px)';
    (e.currentTarget as HTMLButtonElement).style.boxShadow = '0 8px 24px rgba(255,215,0,0.35)';
  }}
  onMouseLeave={e => {
    (e.currentTarget as HTMLButtonElement).style.transform = 'translateY(0)';
    (e.currentTarget as HTMLButtonElement).style.boxShadow = 'none';
  }}
>
  <div style={{
    width: '32px', height: '32px', borderRadius: '8px',
    background: 'rgba(0,0,0,0.12)',
    display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
  }}>
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
      <path d="M5 17H3a1 1 0 0 1-1-1v-5l2.5-6h13L20 11v5a1 1 0 0 1-1 1h-2"
        stroke="#000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <circle cx="7.5" cy="17.5" r="1.5" stroke="#000" strokeWidth="2"/>
      <circle cx="16.5" cy="17.5" r="1.5" stroke="#000" strokeWidth="2"/>
      <path d="M2 11h20" stroke="#000" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  </div>

  See All Cars

  {/* Animated arrows beside text */}
  <div style={{ display: 'flex', alignItems: 'center', gap: '0px' }}>
    <svg className="arr-1" width="10" height="16" viewBox="0 0 10 16" fill="none">
      <path d="M2 2L8 8L2 14" stroke="rgba(0,0,0,0.5)" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
    <svg className="arr-2" width="10" height="16" viewBox="0 0 10 16" fill="none">
      <path d="M2 2L8 8L2 14" stroke="rgba(0,0,0,0.35)" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
    <svg className="arr-3" width="10" height="16" viewBox="0 0 10 16" fill="none">
      <path d="M2 2L8 8L2 14" stroke="rgba(0,0,0,0.2)" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  </div>
</button>

{/* Sell Your Car */}
<button
  onClick={() => navigate('/sellcar')}
  style={{
    display: 'inline-flex', alignItems: 'center', gap: '10px',
    padding: '14px 28px', borderRadius: '12px',
    background: 'transparent', border: '1.5px solid rgba(255,215,0,0.5)',
    cursor: 'pointer', fontSize: isMobile ? '14px' : '15px',
    fontWeight: 700, color: '#FFD700', letterSpacing: '-0.01em',
    width: isMobile ? '100%' : 'auto',
    transition: 'transform 0.2s, background 0.2s, border-color 0.2s',
  }}
  onMouseEnter={e => {
    (e.currentTarget as HTMLButtonElement).style.transform = 'translateY(-2px)';
    (e.currentTarget as HTMLButtonElement).style.background = 'rgba(255,215,0,0.08)';
    (e.currentTarget as HTMLButtonElement).style.borderColor = '#FFD700';
  }}
  onMouseLeave={e => {
    (e.currentTarget as HTMLButtonElement).style.transform = 'translateY(0)';
    (e.currentTarget as HTMLButtonElement).style.background = 'transparent';
    (e.currentTarget as HTMLButtonElement).style.borderColor = 'rgba(255,215,0,0.5)';
  }}
>
  {/* Animated price tag */}
  <div style={{
    width: '32px', height: '32px', borderRadius: '8px',
    background: 'rgba(255,215,0,0.1)',
    display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
  }}>
    <svg className="tag-anim" width="16" height="16" viewBox="0 0 24 24" fill="none">
      <path d="M12 2H7a1 1 0 0 0-.707.293l-4 4A1 1 0 0 0 2 7v5a1 1 0 0 0 .293.707l9 9a1 1 0 0 0 1.414 0l9-9a1 1 0 0 0 0-1.414l-9-9A1 1 0 0 0 12 2Z"
        stroke="#FFD700" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <circle cx="7.5" cy="7.5" r="1" fill="#FFD700"/>
    </svg>
  </div>

  Sell Your Car
</button>

        </div>
      </div>
      
    </section>
  );
}